module.exports = __webpack_public_path__ + "static/product-5-6c2c83e8f19c4e859e6de87e3cad9552.png";